import React, { createContext, useMemo, useState } from "react";
import { useFormStore } from "./store";

const PricePromiseContext = createContext();

const PricePromiseFormProvider = ({ children }) => {
  const [serverError, setServerError] = useState(null);
  const { stateHandlers, elementStates } = useFormStore(state => {
    const { updateResponses, addAttachment, removeAttachment, setAttachmentError, reset, ...remainingElementStates } =
      state;
    return {
      stateHandlers: {
        updateResponses,
        addAttachment,
        removeAttachment,
        setAttachmentError,
        reset,
      },
      elementStates: remainingElementStates,
    };
  });

  const value = useMemo(
    () => ({
      elementStates,
      stateHandlers,
      serverError,
      setServerError,
    }),
    [elementStates, stateHandlers, serverError],
  );

  return <PricePromiseContext.Provider value={value}>{children}</PricePromiseContext.Provider>;
};

export { PricePromiseContext, PricePromiseFormProvider };
